import React from 'react';

const skillGroups = [
  {
    title: 'Languages',
    description: 'Daily drivers for product and platform engineering.',
    skills: ['JavaScript', 'TypeScript', 'Java', 'Python', 'SQL'],
  },
  {
    title: 'Frameworks',
    description: 'Modern web experiences and backend services.',
    skills: ['React', 'Angular', 'Node.js', 'Spring Boot', 'HTML', 'CSS'],
  },
  {
    title: 'Cloud (AWS)',
    description: 'Production-grade systems and data platforms.',
    skills: ['CloudFormation', 'Route 53', 'Lambda', 'Step Functions', 'Glue', 'EC2', 'ECR'],
  },
  {
    title: 'DevOps & Testing',
    description: 'Automation, delivery, and reliability at scale.',
    skills: ['Jenkins', 'Docker', 'Kubernetes', 'CI/CD', 'Jest', 'Mocha', 'Chai'],
  },
  {
    title: 'Data Stores',
    description: 'Analytics, search, and operational data.',
    skills: ['Athena', 'PostgreSQL', 'MongoDB', 'Cassandra', 'Elasticsearch'],
  },
];

const focusAreas = [
  {
    title: 'AI + Automation',
    details:
      'Designing prompt-driven workflows and orchestration to reduce manual operations and accelerate decisions.',
  },
  {
    title: 'Product Engineering',
    details:
      'Building intuitive interfaces and dashboards that translate model insights into action.',
  },
  {
    title: 'Platform Scale',
    details:
      'Architecting cloud-native pipelines that support multi-region, multi-tenant growth.',
  },
];

const Skills = () => {
  return (
    <section className="skills__container">
      <div className="skills-hero">
        <div>
          <p className="resume-eyebrow">Skills</p>
          <h2>Modern engineering toolkit</h2>
          <p>
            I specialize in full-stack delivery, cloud platforms, and AI-enabled automation. Here is a
            snapshot of the technologies I use daily.
          </p>
        </div>
      </div>

      <div className="skills-grid">
        {skillGroups.map((group) => (
          <article key={group.title} className="skill-card">
            <div className="skill-card-header">
              <h3>{group.title}</h3>
              <p>{group.description}</p>
            </div>
            <div className="skill-tags">
              {group.skills.map((skill) => (
                <span key={skill} className="skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="focus-grid">
        {focusAreas.map((area) => (
          <article key={area.title} className="focus-card">
            <h3>{area.title}</h3>
            <p>{area.details}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Skills;
